export default "__VITE_ASSET__Dx5mizLG__"